import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=afc89b7a&scoped=true"
import script from "./Login.vue?vue&type=script&lang=js"
export * from "./Login.vue?vue&type=script&lang=js"
import style0 from "./Login.vue?vue&type=style&index=0&id=afc89b7a&prod&lang=scss&scoped=true"
import style1 from "./Login.vue?vue&type=style&index=1&id=afc89b7a&prod&lang=scss&rel=text%2Fcss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc89b7a",
  null
  
)

export default component.exports